import {
  fmtCompactDateRange,
  fmtDateTime,
} from "../../../../../shared/utils/dateFormat";

function asNumber(value, fallback = 0) {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
}

function asNullableNumber(value) {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

export function normalizeSalesImport(row = {}) {
  return {
    id: asNumber(row.id),
    salesDateFrom: String(row.salesDateFrom || ""),
    salesDateTo: String(row.salesDateTo || ""),
    integratedAt: row.integratedAt || null,
    integratedBy: {
      id: asNullableNumber(row.integratedBy?.id),
      name: String(row.integratedBy?.name || ""),
    },
    distinctProductCount: asNumber(row.distinctProductCount),
    totalSalesAmount: String(row.totalSalesAmount ?? "0"),
  };
}

export function normalizeSalesImportList(response) {
  const data = Array.isArray(response?.data)
    ? response.data.map(normalizeSalesImport)
    : [];

  return {
    data,
    meta: {
      page: asNumber(response?.meta?.page, 1),
      limit: asNumber(response?.meta?.limit, 20),
      totalItems: asNumber(response?.meta?.totalItems),
      totalPages: asNumber(response?.meta?.totalPages),
      hasNextPage: Boolean(response?.meta?.hasNextPage),
      hasPreviousPage: Boolean(response?.meta?.hasPreviousPage),
    },
  };
}

export function formatSalesImportPeriod(row) {
  return fmtCompactDateRange(row?.salesDateFrom, row?.salesDateTo);
}

export function formatSalesImportDateTime(value) {
  return fmtDateTime(value);
}
